<template>
  <div>
    <PageAllow controller="Shops" action="getShopBalanceHistories" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color" v-show="!currentItemMode">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                v-model="options.keyword"
                @text="customerKeyWord = $event"
                :label="$t('capital.customer')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="
                  $permission.permissionAllow('Shops', 'balanceTemplateImport')
                "
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.import", [$t("capital.import")]) }}
              </v-btn>
              <!-- 门店余额历史 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                :href="'/#/capital/shop-balance-snapshots'"
                v-if="
                  $permission.permissionAllow(
                    'Shops',
                    'shopBalanceSnapshots'
                  ) &&
                  settings &&
                  settings.shop_balance_snapshot_time
                "
              >
                <v-icon x-small class="pe-1">fa-history</v-icon>
                {{ $t("capital.shopBalanceSnapshots") }}
              </v-btn>
              <!-- 余额分类 -->
              <v-btn
                small
                color="primary"
                dark
                class="ms-1"
                v-if="$permission.permissionAllow('BalanceCategories', 'index')"
                href="/#/capital/balance-categories"
              >
                {{ $t("capital.balanceCategories") }}
              </v-btn>
              <!-- export -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click="shopBalanceExport()"
                v-if="$permission.permissionAllow('Shops', 'shopBalanceExport')"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>

                {{ $t("capital.export") }}
              </v-btn>
              <v-btn
                v-if="settings && settings.specified_balance_consumption"
                small
                color="print"
                dark
                @click.stop="$router.push('/capital/specified-balance')"
                class="ms-1"
              >
                {{ $t("capital.specifiedBalance") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.shop_user_name"
                    @text="nameKeyWord = $event"
                    :label="$t('capital.shop_user_name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('capital.status.title', [$consts.shopName()])"
                    :items="$consts.shop.status"
                  />
                </v-col>
              </v-row>
              <!-- 状态 -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="shops"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Shops', 'getShopBalanceHistories')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentItemMode = 'view';
                    currentItem = item;
                  "
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("capital.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("capital.detail") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.balance="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            {{ $t("Global.money") }}{{ item.balance | formatMoney }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | shopStatusColor"
              :text-color="item.status | shopStatusTextColor"
            >
              {{ item.status | shopStatusText }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <CapitalDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getCapitalFromAPI()"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('capital.import')"
      downloadFromAPI
      @download="balanceTemplateExport()"
      @import="
        excelFile = $event;
        balanceTemplateImport();
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import Shops from "@/api/shops";
import CapitalDetail from "./plugins/Detail";
import consts from "@/consts";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  customerKeyWord: "",
  nameKeyWord: "",
  status: [0, 1, 2, 3],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("capitals-options")
        ? sessionStorage.getItem("capitals-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    shops: [],
    currentItemMode: null,
    currentItem: null,
    ImportDialog: false,
    excelFile: null,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    CapitalDetail,
    ImportExcelAlert,
    SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: true,
        href: "/capital",
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("capital.Fields.shop_code", [consts.shopName()]),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("capital.Fields.shop_name", [consts.shopName()]),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("capital.Fields.district_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "district.name",
        },
        {
          text: i18n.t("capital.Fields.shop_user_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_user.name",
        },
        {
          text: i18n.t("capital.Fields.tel"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_user.tel",
        },
        {
          text: i18n.t("capital.Fields.status"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("capital.Fields.balance"),
          align: "end",
          class: "text-no-wrap",
          sortable: false,
          value: "balance",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },

    ...mapState(["loading", "stickTableCols", "settings"]),
  },

  mounted() {
    this.getCapitalFromAPI();
  },

  watch: {
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getCapitalFromAPI();
        sessionStorage.setItem(
          "capitals-options",
          JSON.stringify(this.options)
        );
      },
    },
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.customerKeyWord,
        shop_user_name: this.nameKeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getCapitalFromAPI() {
      Shops.fetchForSelect(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shops = response.data.shops;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    shopBalanceExport() {
      Shops.shopBalanceExport(this.options);
    },
    balanceTemplateExport() {
      Shops.balanceTemplateExport(this.options);
    },
    balanceTemplateImport() {
      this.$store.dispatch("fullscreenLoading");
      Shops.balanceTemplateImport(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("capital.import")])
              );
              this.ImportDialog = false;
              this.getCapitalFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },
};
</script>

<style>
</style>